/** Figma Io Website footer (1001:2689) — brand name Aeviot */

import { brandEmails, brandName } from '../config/brand';

export const siteFooter = {
  brandName,
  tagline:
    'Complete platform for developing, deploying, and managing IoT devices with enterprise-grade security.',
  columns: [
    {
      title: 'Platform',
      links: [
        { label: 'Firmware', to: '/developer-guide' },
        { label: 'Device firmware support', to: '/developer-guide' },
        { label: 'Cloud Platform', to: '/' },
        { label: 'IoT cloud infrastructure', to: '/' },
        { label: 'Partner Dashboard', to: '/partner-login' },
        { label: 'White-Label Apps', to: '/' },
      ],
    },
    {
      title: 'Solutions',
      links: [
        { label: 'Smart Switch Manufacturers', to: '/smart-house-real-estate' },
        { label: 'Solutions for switch OEMs', to: '/smart-house-real-estate' },
        { label: 'Smart Lighting Brands', to: '/smart-commercial-lighting' },
        { label: 'LED and bulb manufacturers', to: '/smart-commercial-lighting' },
        { label: 'Smart Plug Manufacturers', to: '/smart-hospitality' },
        { label: 'Plug and socket products', to: '/smart-hospitality' },
        { label: 'Smart Fan Manufacturers', to: '/smart-commercial-lighting' },
        { label: 'Smart fan ecosystem', to: '/smart-house-real-estate' },
      ],
    },
    {
      title: 'Developers',
      links: [
        { label: 'API Documentation', to: '/api-documentation' },
        { label: 'Backend APIs for integration', to: '/api-documentation' },
        { label: 'Tutorials', to: '/developer-guide' },
        { label: 'Community', to: '/contact-us' },
      ],
    },
    {
      title: 'Company',
      links: [
        { label: 'About Us', to: '/about-us' },
        { label: 'Blog', to: '/about-us' },
        { label: 'Careers', to: '/contact-us' },
        { label: 'Contact', to: '/contact-us' },
      ],
    },
  ],
  legal: [
    { label: 'Privacy Policy', to: '/about-us' },
    { label: 'Terms of service', to: '/about-us' },
    { label: 'Cookie Policy', to: '/about-us' },
  ],
  contactEmail: brandEmails.hello,
  contactPhone: '+1 (555) 123-4567',
} as const;
